import { getCategorias, createCategoria, updateCategoria, deleteCategoria } from '../models/categoriaModel.js';
import Swal from 'sweetalert2';
import pb from '../lib/pocketbase';
import { toasts } from "svelte-toasts";

export async function fetchCategorias(page, perPage) {
  try {
    const response = await getCategorias(page, perPage);
    return {
      categoria: response.items,
      totalRecords: response.totalItems,
      currentPage: response.page,
    };
  } catch (error) {
    console.error("Error fetching categorias:", error);
    Swal.fire('Error', 'No se pudieron cargar las categorías', 'error');
    return null;
  }
}

export async function saveCategoria(categoria, currentCategoriaId) {
  try {
    if (currentCategoriaId) {
      await updateCategoria(currentCategoriaId, categoria);
      toasts.add({
        title: 'Éxito',
        description: 'Categoría guardada exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true,
      });
    } else {
      await createCategoria(categoria);
      toasts.add({
        title: 'Éxito',
        description: 'Categoría creada exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true,
      });
    }
  } catch (error) {
    console.error("Error saving categoria:", error);
    toasts.add({
      title: 'Error',
      description: 'Ocurrió un error al guardar la categoría',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true,
    });
  }
}

export async function removeCategoria(id) {
  try {
    await deleteCategoria(id);
    toasts.add({
      title: 'Éxito',
      description: 'Categoría eliminada exitosamente.',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true,
    });
  } catch (error) {
    console.error("Error deleting categoria:", error);
    Swal.fire('Error', 'No se pudo eliminar la categoría', 'error');
  }
}

// Suscripción en tiempo real a cambios en la colección 'categoria'
export function subscribeToCategorias(searchQuery, handleSearch) {
  pb.collection('categoria').subscribe('*', async (e) => {
    console.log('Evento en tiempo real recibido:', e);
    await handleSearch(); // Actualiza la lista manteniendo la página actual
  });
}

// Desuscripción de los eventos en tiempo real
export function unsubscribeFromCategorias() {
  pb.collection('categoria').unsubscribe('*');
}

export async function searchCategorias(query, page = 1, perPage = 10) {
  try {
    const response = await pb.collection('categoria').getList(page, perPage, {
      filter: `descrip ~ "${query}"`,
      expand: 'parent'
    });
    return {
      categoria: response.items,
      totalRecords: response.totalItems,
      currentPage: response.currentPage,
    };
  } catch (error) {
    console.error("Error searching categorias:", error);
    Swal.fire('Error', 'No se pudieron buscar las categorías', 'error');
    return null;
  }
}

// Get categorias for dropdown (hierarchical)
export async function getCategoriasForDropdown() {
  try {
    const response = await pb.collection('categoria').getFullList({
      sort: 'descrip',
      expand: 'parent'
    });
    
    return response.map(categoria => ({
      key: categoria.id,
      value: categoria.descrip,
      parent: categoria.parent
    }));
  } catch (error) {
    console.error("Error fetching categorias for dropdown:", error);
    return [];
  }
}

// Get categorias for a specific producto
export async function fetchCategoriasProducto(productoId) {
  try {
    const response = await pb.collection('categoria_producto').getList(1, 50, {
      filter: `producto="${productoId}"`,
      expand: 'categoria',
      $autoCancel: false
    });
    
    return response.items.map(item => ({
      id: item.id,
      categoria: item.expand?.categoria || item.categoria
    }));
  } catch (error) {
    console.error('Error fetching categorias producto:', error);
    return [];
  }
}

// Save categorias for a producto
export async function saveCategoriasProducto(productoId, categorias) {
  // Elimina las categorías existentes antes de guardar las nuevas
  await deleteCategoriasProducto(productoId);
  
  try {
    // Itera sobre cada categoría y guarda en la colección 'categoria_producto'
    for (const categoria of categorias) {
      await pb.collection('categoria_producto').create({
        producto: productoId,
        categoria: categoria.id,
      });
    }

    toasts.add({
      title: 'Éxito',
      description: 'Categorías del producto actualizadas exitosamente',
      duration: 3000,
      placement: 'bottom-right',
      type: 'success',
      theme: 'dark',
      showProgress: true,
    });
  } catch (error) {
    console.error('Error guardando categorías del producto:', error);
    toasts.add({
      title: 'Error',
      description: 'No se pudieron guardar las categorías del producto',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true,
    });
  }
}

// Delete categorias for a producto
export async function deleteCategoriasProducto(productoId) {
  try {
    const categorias = await pb.collection('categoria_producto').getFullList({
      filter: `producto = "${productoId}"`
    });
    
    for (const categoria of categorias) {
      await pb.collection('categoria_producto').delete(categoria.id);
    }
  } catch (error) {
    console.error('Error eliminando categorías del producto:', error);
  }
}
